import axios from 'axios';

const publicClient = axios.create();

export {publicClient};
